// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1_UCd","list":"BalanceDue_list__3pts0","listRow":"BalanceDue_listRow__e_hlW","total":"BalanceDue_total__1DIV0"};